import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";

interface Props {
  dataLength: number;
  next: () => void;
  loader?: any;
  hasMore: boolean;
  children?: React.ReactNode;
  endMessage?: any;
  scrollableTarget?: string;
  scrollThreshold?: string | number;
}

const InfiniteLoader: React.FC<Props> = (props) => {
  return (
    <InfiniteScroll
      {...props}
      style={{
        overflow: "visible",
      }}
      dataLength={props.dataLength}
      next={() => props.next()}
      hasMore={props.hasMore}
      loader={props.loader || <div id="loading">Loading ...</div>}
    >
      {props.children}
    </InfiniteScroll>
  );
};

export default InfiniteLoader;
